import React from 'react';
import ReactDOM from 'react-dom';
import { loadIntlDataForLocale } from 'common/utils/intl';
import { refreshCsrfToken } from 'common/utils/xhr';
import BookCalculator from 'book-calculator/containers/BookCalculator';
import { loadDefaultAttributes } from 'book-calculator/actions/loadDefaultAttributes';
import { loadDefaultAmounts } from 'book-calculator/actions/loadDefaultAmounts';
import { loadFieldOptions } from 'book-calculator/actions/loadFieldOptions';
import { IntlProvider } from 'react-intl';
import Fluxible from 'fluxible';
import FluxibleComponent from 'fluxible-addons-react/FluxibleComponent';
import BookCalculatorAttributesStore from 'stores/BookCalculatorAttributesStore';
import BookCalculatorAmountStore from 'stores/BookCalculatorAmountStore';
import BookCalculatorFieldOptionStore from 'stores/BookCalculatorFieldOptionStore';

const root = document.querySelector('[data-book-calculator-app]');
const app = new Fluxible();
const ctx = app.createContext({});

app.registerStore(BookCalculatorAttributesStore);
app.registerStore(BookCalculatorAmountStore);
app.registerStore(BookCalculatorFieldOptionStore);

loadIntlDataForLocale(document.documentElement.lang)
    .then(() => refreshCsrfToken())
    .then(
        ctx
            .getActionContext()
            .executeAction(loadDefaultAttributes, window.bookCalculator.defaultData)
    )
    .then(
        ctx
            .getActionContext()
            .executeAction(loadDefaultAmounts, window.bookCalculator.defaultAmounts)
    )
    .then(
        ctx.getActionContext().executeAction(loadFieldOptions, window.bookCalculator.fieldOptions)
    )
    .then(() => {
        ReactDOM.render(
            <FluxibleComponent context={ctx.getComponentContext()}>
                <IntlProvider
                    locale={document.documentElement.lang}
                    messages={window.intlData.messages}
                >
                    <BookCalculator />
                </IntlProvider>
            </FluxibleComponent>,
            root
        );
    });
